module.exports = __webpack_public_path__ + "static/media/howwork-hover1-1.15343d40.svg";